import {useAppDispatch} from "../redux/stateHooks";
import {
    clearArtworkFile,
    clearArtworkNotes,
    clearDesignService,
    clearDimensions,
    clearWarranty
} from "../redux/slices/addToCart";

export function useClearProduct() {
    const dispatch = useAppDispatch();

    return {
        /**
         * Clears out all the product-specific state, minus promotion code.
         * This is since the promotion code may not be product-specific and if it is applicable to the next product,
         * we want to keep it
         * @public
         */
        clearProduct: () => {
            dispatch(clearArtworkFile());
            dispatch(clearArtworkNotes());
            dispatch(clearWarranty());
            dispatch(clearDesignService());
            dispatch(clearDimensions());
        }
    }
}